/* =========================================================================
   Momentum — JavaScript du thème
   Aucune dépendance externe. Tout est natif (fetch + DOM).
   ========================================================================= */
(function () {
  'use strict';

  var body = document.body;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------------
     Formatage monétaire (basé sur shop.money_format)
     --------------------------------------------------------------------- */
  var MONEY_FORMAT = body.getAttribute('data-money-format') || '{{amount}} €';

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;

    function num(value, precision, thousands, decimal) {
      if (isNaN(value) || value === null) return '0';
      value = (value / 100).toFixed(precision);
      var parts = value.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var tail = parts[1] ? decimal + parts[1] : '';
      return head + tail;
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = MONEY_FORMAT.match(placeholder);
    var name = match ? match[1] : 'amount';
    var value;

    switch (name) {
      case 'amount': value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2, ',', '.');
    }
    return MONEY_FORMAT.replace(placeholder, value);
  }

  /* ---------------------------------------------------------------------
     Overlay + verrouillage du scroll
     --------------------------------------------------------------------- */
  var overlay = $('[data-overlay]');
  var openPanels = 0;

  function showOverlay() {
    openPanels++;
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    body.classList.add('is-locked');
  }

  function hideOverlay() {
    openPanels = Math.max(0, openPanels - 1);
    if (openPanels > 0 || !overlay) return;
    overlay.classList.remove('is-visible');
    body.classList.remove('is-locked');
    setTimeout(function () { if (openPanels === 0) overlay.hidden = true; }, 260);
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeCartDrawer();
      closeMobileMenu();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCartDrawer(); closeMobileMenu(); }
  });

  /* ---------------------------------------------------------------------
     Barre d'annonce : rotation + compte à rebours
     --------------------------------------------------------------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var slides = $$('.announcement__slide', bar);
    if (slides.length > 1) {
      var i = 0;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4000;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    }
  });

  function runCountdown(el, valueEl, minutes, storageKey) {
    var total = minutes * 60 * 1000;
    var end;
    try {
      var saved = sessionStorage.getItem(storageKey);
      end = saved ? parseInt(saved, 10) : 0;
      if (!end || end < Date.now()) {
        end = Date.now() + total;
        sessionStorage.setItem(storageKey, String(end));
      }
    } catch (err) {
      end = Date.now() + total;
    }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        end = Date.now() + total;
        try { sessionStorage.setItem(storageKey, String(end)); } catch (err) {}
        left = total;
      }
      var totalSec = Math.floor(left / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      valueEl.textContent = (h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  $$('[data-countdown]').forEach(function (el) {
    var valueEl = $('[data-countdown-time]', el);
    if (!valueEl) return;
    runCountdown(el, valueEl, parseInt(el.getAttribute('data-minutes'), 10) || 30, 'momentum_promo_end');
  });

  function initCartTimers() {
    $$('[data-cart-timer]').forEach(function (el) {
      if (el.dataset.timerReady) return;
      var valueEl = $('[data-cart-timer-value]', el);
      if (!valueEl) return;
      el.dataset.timerReady = '1';
      runCountdown(el, valueEl, parseInt(el.getAttribute('data-minutes'), 10) || 10, 'momentum_cart_end');
    });
  }
  initCartTimers();

  /* ---------------------------------------------------------------------
     Menu mobile
     --------------------------------------------------------------------- */
  var mobileMenu = $('[data-mobile-menu]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    requestAnimationFrame(function () { mobileMenu.classList.add('is-open'); });
    showOverlay();
  }

  function closeMobileMenu() {
    if (!mobileMenu || !mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.remove('is-open');
    hideOverlay();
    setTimeout(function () { mobileMenu.hidden = true; }, 300);
  }

  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', openMobileMenu); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMobileMenu); });

  /* ---------------------------------------------------------------------
     Panier : API + rendu du tiroir
     --------------------------------------------------------------------- */
  var cartDrawer = $('[data-cart-drawer]');
  var CART_TYPE = body.getAttribute('data-cart-type') || 'drawer';
  var FREE_SHIP = parseInt(body.getAttribute('data-free-shipping'), 10) || 0;
  var R_ADD = body.getAttribute('data-routes-cart-add') || '/cart/add';
  var R_CHANGE = body.getAttribute('data-routes-cart-change') || '/cart/change';
  var R_CART = body.getAttribute('data-routes-cart') || '/cart';

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
    showOverlay();
    initCartTimers();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    cartDrawer.classList.remove('is-open');
    hideOverlay();
    setTimeout(function () { cartDrawer.hidden = true; }, 320);
  }

  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCartDrawer); });

  $$('[data-cart-open]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (CART_TYPE !== 'drawer' || !cartDrawer) return;
      e.preventDefault();
      fetchCart().then(renderCart).then(openCartDrawer);
    });
  });

  function fetchCart() {
    return fetch(R_CART + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateShippingBar(cart) {
    $$('[data-shipbar]').forEach(function (bar) {
      var msg = $('[data-shipbar-msg]', bar);
      var fill = $('[data-shipbar-fill]', bar);
      if (!FREE_SHIP) { bar.style.display = 'none'; return; }
      var total = cart.total_price;
      var remaining = FREE_SHIP - total;
      var pct = Math.min(100, Math.round((total / FREE_SHIP) * 100));
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        msg.innerHTML = remaining > 0
          ? 'Plus que <strong>' + formatMoney(remaining) + '</strong> pour la livraison offerte'
          : '🎉 <strong>Livraison offerte</strong> débloquée !';
      }
    });
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    updateShippingBar(cart);

    var container = $('[data-cart-items]');
    if (!container) return cart;

    if (!cart.items.length) {
      container.innerHTML =
        '<div class="drawer__empty"><p>Votre panier est vide.</p>' +
        '<a href="/collections/all" class="btn btn--primary">Découvrir la boutique</a></div>';
      return cart;
    }

    container.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy" width="74" height="74">'
        : '';
      var variant = (item.product_has_only_default_variant || !item.variant_title)
        ? '' : '<p class="ditem__variant">' + item.variant_title + '</p>';
      var compare = item.original_line_price > item.final_line_price
        ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';

      return '' +
        '<article class="ditem" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="ditem__media">' + img + '</a>' +
          '<div>' +
            '<a href="' + item.url + '" class="ditem__title">' + item.product_title + '</a>' +
            variant +
            '<div class="qty">' +
              '<button type="button" data-cart-minus data-key="' + item.key + '" aria-label="Diminuer">−</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-cart-input data-key="' + item.key + '" aria-label="Quantité">' +
              '<button type="button" data-cart-plus data-key="' + item.key + '" aria-label="Augmenter">+</button>' +
            '</div>' +
            '<button type="button" class="ditem__remove" data-cart-remove data-key="' + item.key + '">Supprimer</button>' +
          '</div>' +
          '<div class="ditem__price">' + compare + formatMoney(item.final_line_price) + '</div>' +
        '</article>';
    }).join('');

    return cart;
  }

  function changeLine(key, quantity) {
    return fetch(R_CHANGE + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  // Accepte soit (id, quantité, plan), soit directement un tableau d'articles
  // — un lot part alors en une seule requête, donc en une seule ligne d'historique.
  function addToCart(id, quantity, sellingPlan) {
    var items;
    if (Array.isArray(id)) {
      items = id;
    } else {
      var item = { id: Number(id), quantity: Number(quantity) || 1 };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      items = [item];
    }
    return fetch(R_ADD + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  // Délégation : steppers et suppression, dans le tiroir comme sur la page panier
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-minus]');
    var plus = e.target.closest('[data-cart-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    if (!minus && !plus && !remove) return;

    var el = minus || plus || remove;
    var key = el.getAttribute('data-key');
    var onCartPage = !!document.querySelector('[data-cart-page]');
    var quantity = 0;

    if (!remove) {
      var input = document.querySelector('[data-cart-input][data-key="' + key + '"]');
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      quantity = plus ? current + 1 : Math.max(0, current - 1);
    }

    e.preventDefault();
    el.disabled = true;

    changeLine(key, quantity).then(function (cart) {
      if (onCartPage) { window.location.reload(); return; }
      renderCart(cart);
    }).catch(function () { el.disabled = false; });
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-input]');
    if (!input) return;
    var onCartPage = !!document.querySelector('[data-cart-page]');
    changeLine(input.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0))
      .then(function (cart) {
        if (onCartPage) { window.location.reload(); return; }
        renderCart(cart);
      });
  });

  /* ---------------------------------------------------------------------
     Ajout au panier (formulaires produit + ajout rapide)
     --------------------------------------------------------------------- */
  function handleAdd(id, qty, button, sellingPlan) {
    var original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Ajout…'; }

    return addToCart(id, qty, sellingPlan)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        if (button) { button.innerHTML = '✓ Ajouté'; }
        if (CART_TYPE === 'drawer' && cartDrawer) {
          openCartDrawer();
        } else {
          window.location.href = R_CART;
          return;
        }
        setTimeout(function () {
          if (button) { button.disabled = false; button.innerHTML = original; }
        }, 1400);
      })
      .catch(function (err) {
        if (button) {
          button.innerHTML = (err && err.description) ? 'Indisponible' : 'Erreur';
          setTimeout(function () { button.disabled = false; button.innerHTML = original; }, 1800);
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form], form#ProductForm');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;

    // Plan d'abonnement : le nôtre, ou celui qu'une application a injecté
    // dans le formulaire (Seal et consorts posent un champ selling_plan).
    var planInput = form.querySelector('[name="selling_plan"]:not(:disabled)');
    var plan = planInput && planInput.value ? planInput.value : '';

    // Offre « lot » : un second article part dans la même requête.
    var extras = [];
    try {
      extras = JSON.parse(form.getAttribute('data-extra-items') || '[]');
    } catch (err) { extras = []; }

    if (extras.length) {
      var items = [{ id: Number(idInput.value), quantity: qty }];
      if (plan) items[0].selling_plan = Number(plan);
      handleAdd(items.concat(extras), null, button);
    } else {
      handleAdd(idInput.value, qty, button, plan);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    handleAdd(btn.getAttribute('data-variant-id'), 1, btn);
  });

  // Premier calcul de la barre de livraison au chargement
  if ($('[data-shipbar]')) fetchCart().then(updateShippingBar);

  /* ---------------------------------------------------------------------
     Carrousels génériques (flèches)
     --------------------------------------------------------------------- */
  $$('[data-carousel-track]').forEach(function (track) {
    var scope = track.closest('section') || document;
    var prev = $('[data-carousel-prev]', scope);
    var next = $('[data-carousel-next]', scope);
    var step = function () {
      var item = track.firstElementChild;
      return item ? item.getBoundingClientRect().width + 20 : 280;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------------------------------------------------------------------
     Avis clients
     --------------------------------------------------------------------- */
  $$('[data-reviews]').forEach(function (section) {
    var dataEl = $('[data-reviews-data]', section);
    var track = $('[data-reviews-track]', section);
    if (!dataEl || !track) return;

    var reviews;
    try { reviews = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!Array.isArray(reviews) || !reviews.length) return;

    var perPage = parseInt(section.getAttribute('data-per-page'), 10) || 9;
    var isCarousel = !!$('.rcarousel', section);
    var filter = 'all';
    var shown = perPage;

    function initials(name) {
      return name.split(' ').map(function (p) { return p.charAt(0); }).join('').slice(0, 2).toUpperCase();
    }

    function starsHtml(rating) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        out += '<svg class="icon icon--star" viewBox="0 0 20 20" width="13" height="13" fill="currentColor"' +
               (i <= rating ? '' : ' opacity=".26"') +
               '><path d="M10 1.6l2.5 5.3 5.7.8-4.1 4 1 5.7L10 14.7 4.9 17.4l1-5.7-4.1-4 5.7-.8z"/></svg>';
      }
      return '<span class="stars">' + out + '</span>';
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function cardHtml(r) {
      return '' +
        '<article class="rcard">' +
          '<div class="rcard__top">' + starsHtml(r.rating) + '<span class="rcard__date">' + escapeHtml(r.date) + '</span></div>' +
          '<h3 class="rcard__title">' + escapeHtml(r.title) + '</h3>' +
          '<p class="rcard__body">' + escapeHtml(r.body) + '</p>' +
          (r.product ? '<p class="rcard__product">Produit : ' + escapeHtml(r.product) + '</p>' : '') +
          '<div class="rcard__foot">' +
            '<span class="rcard__avatar">' + escapeHtml(initials(r.name)) + '</span>' +
            '<span class="rcard__who"><strong>' + escapeHtml(r.name) + '</strong><span>' + escapeHtml(r.location) + '</span></span>' +
            (r.verified ? '<span class="rcard__verified">✓ Vérifié</span>' : '') +
          '</div>' +
        '</article>';
    }

    function filtered() {
      return filter === 'all'
        ? reviews
        : reviews.filter(function (r) { return String(r.rating) === filter; });
    }

    function render() {
      var list = filtered();
      var slice = isCarousel ? list : list.slice(0, shown);
      track.innerHTML = slice.map(cardHtml).join('') ||
        '<p style="color:var(--muted)">Aucun avis pour cette note.</p>';

      var more = $('[data-reviews-more]', section);
      if (more) more.style.display = (!isCarousel && shown < list.length) ? '' : 'none';
    }

    // Résumé : moyenne + répartition
    var avgEl = $('[data-reviews-average]', section);
    var totalEl = $('[data-reviews-total]', section);
    var barsEl = $('[data-reviews-bars]', section);

    var sum = reviews.reduce(function (acc, r) { return acc + r.rating; }, 0);
    var average = sum / reviews.length;
    if (avgEl) avgEl.textContent = average.toFixed(1).replace('.', ',');
    if (totalEl) totalEl.textContent = reviews.length;

    if (barsEl) {
      var html = '';
      for (var star = 5; star >= 1; star--) {
        var count = reviews.filter(function (r) { return r.rating === star; }).length;
        var pct = Math.round((count / reviews.length) * 100);
        html += '<div class="rbar" data-star="' + star + '"><span>' + star + ' ★</span>' +
                '<span class="rbar__track"><span class="rbar__fill" style="width:' + pct + '%"></span></span>' +
                '<span>' + pct + '%</span></div>';
      }
      barsEl.innerHTML = html;
    }

    // Filtres
    $$('[data-filter]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-filter]', section).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        filter = btn.getAttribute('data-filter');
        shown = perPage;
        render();
      });
    });

    var moreBtn = $('[data-reviews-more]', section);
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += perPage; render(); });

    var rPrev = $('[data-reviews-prev]', section);
    var rNext = $('[data-reviews-next]', section);
    var rStep = function () {
      var c = track.firstElementChild;
      return c ? c.getBoundingClientRect().width + 18 : 340;
    };
    if (rPrev) rPrev.addEventListener('click', function () { track.scrollBy({ left: -rStep(), behavior: 'smooth' }); });
    if (rNext) rNext.addEventListener('click', function () { track.scrollBy({ left: rStep(), behavior: 'smooth' }); });

    render();
  });

  /* ---------------------------------------------------------------------
     Comparateur avant / après
     --------------------------------------------------------------------- */
  $$('[data-ba]').forEach(function (ba) {
    var range = $('[data-ba-range]', ba);
    var before = $('[data-ba-before]', ba);
    var handle = $('[data-ba-handle]', ba);
    if (!range || !before) return;

    function apply() {
      var v = range.value;
      before.style.width = v + '%';
      var img = before.querySelector('img, svg');
      if (img) img.style.width = (10000 / Math.max(v, 1)) + '%';
      if (handle) handle.style.left = v + '%';
    }
    range.addEventListener('input', apply);
    apply();
  });

  /* ---------------------------------------------------------------------
     Page produit : galerie, variantes, quantité, paliers, barre collante
     --------------------------------------------------------------------- */
  $$('[data-product-section]').forEach(function (section) {

    /* --- Galerie --- */
    var slides = $$('[data-gallery-slide]', section);
    var thumbs = $$('[data-gallery-thumb]', section);
    var current = 0;

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
      var activeThumb = thumbs[current];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); });
    });
    var gPrev = $('[data-gallery-prev]', section);
    var gNext = $('[data-gallery-next]', section);
    if (gPrev) gPrev.addEventListener('click', function () { goTo(current - 1); });
    if (gNext) gNext.addEventListener('click', function () { goTo(current + 1); });

    // Zoom au clic
    $$('img[data-zoomable]', section).forEach(function (img) {
      img.addEventListener('click', function () { img.classList.toggle('is-zoomed'); });
      img.addEventListener('mousemove', function (e) {
        if (!img.classList.contains('is-zoomed')) return;
        var rect = img.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - rect.left) / rect.width * 100) + '% ' +
          ((e.clientY - rect.top) / rect.height * 100) + '%';
      });
      img.addEventListener('mouseleave', function () {
        img.classList.remove('is-zoomed');
        img.style.transformOrigin = '';
      });
    });

    /* --- Variantes --- */
    var variantsEl = $('[data-product-variants]', section);
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (err) { variants = []; }

    var variantInput = $('[data-variant-input]', section);
    var priceTarget = $('[data-price-target]', section);
    var atc = $('[data-atc]', section);
    var atcText = $('[data-atc-text]', section);
    var atcPrice = $('[data-atc-price]', section);
    var stickyBar = $('[data-sticky-bar]');
    var stickyPrice = stickyBar ? $('[data-sticky-price]', stickyBar) : null;
    var stickyAtc = stickyBar ? $('[data-sticky-atc]', stickyBar) : null;
    var qtyInput = $('[data-qty-input]', section);
    var formQty = $('[data-quantity-input]', section);
    var currentVariant = variants.length ? variants[0] : null;

    // Variante initiale = celle marquée disponible/sélectionnée côté Liquid
    if (variantInput && variants.length) {
      var initial = variants.filter(function (v) { return String(v.id) === String(variantInput.value); })[0];
      if (initial) currentVariant = initial;
    }

    function selectedOptions() {
      var values = [];
      $$('[data-option-group]', section).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input[data-option-input]:checked');
        var select = group.querySelector('select[data-option-input]');
        values[idx] = checked ? checked.value : (select ? select.value : null);
      });
      return values;
    }

    function priceHtml(v) {
      if (!v) return '';
      var out = '<span class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '">' +
                '<span class="price__current">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price > v.price) {
        var saved = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        out += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' +
               '<span class="price__badge">-' + saved + ' %</span>';
      }
      return out + '</span>';
    }

    var planInput = $('[data-selling-plan-input]', section);
    var productForm = $('form#ProductForm', section) || $('form[data-product-form]', section);

    function currentOffer() {
      return section.querySelector('[data-offer-input]:checked');
    }

    // Offre vendant un autre produit : on suit la couleur choisie sur la page
    // quand ce produit propose la même valeur d'option.
    function offerVariantId(offer) {
      var id = offer.getAttribute('data-variant-id');
      var raw = offer.getAttribute('data-variant-map');
      if (raw && currentVariant) {
        try {
          var map = JSON.parse(raw);
          var key = currentVariant.option1;
          if (key && map[key]) return String(map[key]);
        } catch (err) {}
      }
      return id;
    }

    function isPageVariant(offer) {
      var id = offer.getAttribute('data-variant-id');
      if (!id) return true;
      return variants.some(function (v) { return String(v.id) === String(id); });
    }

    function currentQty() {
      var offer = currentOffer();
      if (offer) return parseInt(offer.getAttribute('data-qty'), 10) || 1;
      return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    }

    // Prix réel d'une offre, tel que Shopify le renvoie — jamais un calcul maison.
    function offerPrice(offer, v) {
      var qty = parseInt(offer.getAttribute('data-qty'), 10) || 1;
      var mode = offer.getAttribute('data-mode');
      var plan = offer.getAttribute('data-selling-plan');

      // Offre qui vend un autre produit : son prix est figé côté Liquid,
      // la variante de la page n'a rien à voir avec lui.
      if (offer.getAttribute('data-variant-id') && !isPageVariant(offer)) {
        return (parseInt(offer.getAttribute('data-base-price'), 10) || 0) * qty;
      }

      if (mode === 'subscription' && plan && v.selling_plan_allocations) {
        for (var i = 0; i < v.selling_plan_allocations.length; i++) {
          var a = v.selling_plan_allocations[i];
          if (String(a.selling_plan_id) === String(plan)) return a.price * qty;
        }
      }
      var total = v.price * qty;
      if (mode === 'bundle') {
        var ep = parseInt(offer.getAttribute('data-extra-price'), 10) || 0;
        var eq = parseInt(offer.getAttribute('data-extra-qty'), 10) || 0;
        total += ep * eq;
      }
      return total;
    }

    // Reporte l'offre choisie sur le formulaire : plan d'abonnement et articles du lot.
    function applyOffer() {
      var offer = currentOffer();
      if (!productForm) return;

      var plan = offer ? offer.getAttribute('data-selling-plan') : '';
      var isSub = offer && offer.getAttribute('data-mode') === 'subscription';
      if (planInput) {
        planInput.value = isSub && plan ? plan : '';
        planInput.disabled = !(isSub && plan);
      }

      // Offre vendant un autre produit : c'est sa variante qui part au panier.
      if (offer && variantInput) {
        var oid = offerVariantId(offer);
        if (oid && !isPageVariant(offer)) variantInput.value = oid;
        else if (currentVariant) variantInput.value = currentVariant.id;
      }

      var extras = [];
      if (offer && offer.getAttribute('data-mode') === 'bundle') {
        var eid = offer.getAttribute('data-extra-id');
        var eq = parseInt(offer.getAttribute('data-extra-qty'), 10) || 0;
        if (eid && eq > 0) extras.push({ id: Number(eid), quantity: eq });
      }
      productForm.setAttribute('data-extra-items', JSON.stringify(extras));
    }

    function refresh() {
      if (!currentVariant) return;
      var qty = currentQty();

      var ofr = currentOffer();
      var external = ofr && ofr.getAttribute('data-variant-id') && !isPageVariant(ofr);
      if (variantInput && !external) variantInput.value = currentVariant.id;
      if (formQty) formQty.value = qty;
      if (priceTarget) priceTarget.innerHTML = priceHtml(currentVariant);
      if (atcPrice) atcPrice.textContent = formatMoney(currentVariant.price * qty);
      if (stickyPrice) stickyPrice.textContent = formatMoney(currentVariant.price * qty);

      var available = currentVariant.available;
      if (atc) atc.disabled = !available;
      if (stickyAtc) stickyAtc.disabled = !available;
      if (atcText) atcText.textContent = available ? (atcText.getAttribute('data-label') || atcText.textContent.replace('Épuisé', 'Ajouter au panier')) : 'Épuisé';
      if (!available && atcText) atcText.textContent = 'Épuisé';

      // Prix de chaque offre
      $$('[data-offer-input]', section).forEach(function (input) {
        var el = input.parentNode.querySelector('[data-offer-price]');
        if (el) el.textContent = formatMoney(offerPrice(input, currentVariant));
      });

      // Le bouton et la barre collante affichent le prix de l'offre choisie
      var chosen = currentOffer();
      if (chosen) {
        var total = offerPrice(chosen, currentVariant);
        if (atcPrice) atcPrice.textContent = formatMoney(total);
        if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      }

      // Étiquette de l'option sélectionnée
      $$('[data-option-group]', section).forEach(function (group) {
        var label = $('[data-option-selected]', group);
        var checked = group.querySelector('input[data-option-input]:checked');
        var select = group.querySelector('select[data-option-input]');
        if (label) label.textContent = checked ? checked.value : (select ? select.value : '');
      });

      // URL sans rechargement
      if (window.history.replaceState && currentVariant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function onOptionChange() {
      var values = selectedOptions();
      var match = variants.filter(function (v) {
        return values.every(function (val, i) { return val === null || v['option' + (i + 1)] === val; });
      })[0];
      if (match) currentVariant = match;

      $$('.swatch', section).forEach(function (sw) {
        var input = sw.querySelector('input');
        sw.classList.toggle('is-active', !!(input && input.checked));
      });
      refresh();
    }

    $$('[data-option-input]', section).forEach(function (input) {
      input.addEventListener('change', onOptionChange);
    });

    /* --- Paliers de quantité --- */
    $$('[data-offer-input]', section).forEach(function (input) {
      input.addEventListener('change', function () {
        $$('.offer', section).forEach(function (o) {
          var i = o.querySelector('input');
          o.classList.toggle('is-active', !!(i && i.checked));
        });
        applyOffer();
        refresh();
      });
    });
    applyOffer();

    // Changer de couleur doit aussi remapper l'offre en cours.
    section.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-option-input')) applyOffer();
    });

    /* --- Stepper de quantité --- */
    var qMinus = $('[data-qty-minus]', section);
    var qPlus = $('[data-qty-plus]', section);
    if (qtyInput) {
      if (qMinus) qMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); refresh();
      });
      if (qPlus) qPlus.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; refresh();
      });
      qtyInput.addEventListener('change', refresh);
    }

    /* --- Livraison estimée --- */
    var est = $('[data-delivery-estimate]', section);
    if (est) {
      var min = parseInt(est.getAttribute('data-min'), 10) || 2;
      var max = parseInt(est.getAttribute('data-max'), 10) || 4;
      var fmt = function (days) {
        var d = new Date();
        d.setDate(d.getDate() + days);
        return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      };
      est.textContent = 'entre le ' + fmt(min) + ' et le ' + fmt(max);
    }

    /* --- Barre d'achat collante --- */
    if (stickyBar && atc) {
      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          handleAdd(variantInput ? variantInput.value : currentVariant.id, currentQty(), stickyAtc);
        });
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickyBar.hidden = false;
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { rootMargin: '-120px 0px 0px 0px' });
        observer.observe(atc);
      }
    }

    refresh();
  });

  /* ---------------------------------------------------------------------
     Accordéons : fermeture des voisins
     --------------------------------------------------------------------- */
  $$('.faq__list, .pdp__info').forEach(function (group) {
    var items = $$('details', group);
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  });

  /* ---------------------------------------------------------------------
     Mise en page adaptative : décalage des éléments collants
     Mesure la hauteur réelle de l'en-tête (annonce comprise) pour que les
     colonnes collantes ne passent jamais dessous, quel que soit l'écran.
     --------------------------------------------------------------------- */
  (function stickyOffset() {
    var header = $('[data-header]');
    if (!header) return;

    function apply() {
      var h = header.getBoundingClientRect().height;
      var isSticky = header.classList.contains('header--sticky');
      var offset = (isSticky ? h : 0) + 16;
      document.documentElement.style.setProperty('--sticky-top', Math.round(offset) + 'px');
    }

    apply();
    window.addEventListener('resize', apply);
    window.addEventListener('orientationchange', function () { setTimeout(apply, 220); });
    if ('ResizeObserver' in window) new ResizeObserver(apply).observe(header);
  })();

  /* ---------------------------------------------------------------------
     Balayage tactile sur la galerie produit (mobile / tablette)
     --------------------------------------------------------------------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var stage = $('.gallery__stage', gallery);
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (!stage || (!prev && !next)) return;

    var startX = 0, startY = 0, tracking = false;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      // Geste horizontal franc uniquement : on ne vole pas le défilement vertical
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
      if (dx < 0 && next) next.click();
      if (dx > 0 && prev) prev.click();
    }, { passive: true });
  });

  /* ---------------------------------------------------------------------
     Analyse de l'eau par code postal
     Les fourchettes viennent de snippets/water-data.liquid. Ce sont des
     estimations départementales : le texte le dit et renvoie à la source.
     --------------------------------------------------------------------- */
  $$('[data-water-check]').forEach(function (section) {
    var dataEl = $('[data-water-data]', section);
    var form = $('[data-water-form]', section);
    var input = $('[data-water-input]', section);
    var result = $('[data-water-result]', section);
    if (!dataEl || !form || !input || !result) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var elValue = $('[data-water-value]', section);
    var elPlace = $('[data-water-place]', section);
    var elBadge = $('[data-water-badge]', section);
    var elMarker = $('[data-water-marker]', section);
    var elText = $('[data-water-text]', section);
    var elFacts = $('[data-water-facts]', section);
    var elUrgency = $('[data-water-urgency]', section);
    var elHint = $('[data-water-hint]', section);
    var hintBase = elHint ? elHint.textContent : '';

    // Cinq niveaux, du plus doux au plus chargé
    var LEVELS = [
      {
        max: 8, key: 'tres-douce', label: 'Eau très douce',
        text: "Votre eau est très douce : le calcaire n'est pas votre problème. Le chlore, lui, reste présent — c'est le traitement qui rend l'eau potable jusqu'à votre robinet, partout en France.",
        facts: [
          "Très peu de dépôt de calcaire sur la peau et les cheveux",
          "Le chlore reste le principal irritant de votre eau de douche",
          "Une eau douce peut assécher davantage si elle est fortement chlorée"
        ]
      },
      {
        max: 15, key: 'douce', label: 'Eau douce',
        text: "Votre eau est douce. Le calcaire y est peu présent, ce qui épargne vos cheveux et votre robinetterie. Reste le chlore, systématique dans le réseau français, et c'est lui qui fragilise le film hydrolipidique de la peau.",
        facts: [
          "Peu ou pas de traces blanches sur la paroi de douche",
          "Le savon mousse facilement",
          "Le chlore reste le facteur à traiter"
        ]
      },
      {
        max: 25, key: 'moyenne', label: 'Eau moyennement dure',
        text: "Votre eau est moyennement dure. Le calcaire commence à se déposer : sur la robinetterie d'abord, sur la peau et les cheveux ensuite, un peu plus à chaque douche. Le chlore s'y ajoute.",
        facts: [
          "Traces blanches visibles au bout de quelques jours",
          "Cheveux un peu plus lourds en fin de semaine",
          "Peau qui tire parfois après la douche"
        ]
      },
      {
        max: 35, key: 'dure', label: 'Eau dure',
        text: "Votre eau est dure. Le calcaire est nettement présent : il entartre, il dépose, il alourdit les cheveux et laisse un film qui assèche la peau. Combiné au chlore, c'est l'agression quotidienne la plus courante en France.",
        facts: [
          "Dépôt blanc récurrent sur la paroi et la robinetterie",
          "Cheveux ternes et alourdis malgré les soins",
          "Peau qui tire régulièrement en sortant de la douche"
        ]
      },
      {
        max: 999, key: 'tres-dure', label: 'Eau très dure',
        text: "Votre eau est très dure — parmi les plus chargées de France. Le calcaire est partout : bouilloire, robinetterie, paroi de douche. Sur la peau et les cheveux, le dépôt est quotidien, et le chlore vient s'y ajouter.",
        facts: [
          "Entartrage rapide de tous les équipements",
          "Savon et shampoing qui moussent difficilement",
          "Peau et cuir chevelu souvent inconfortables"
        ]
      }
    ];

    function levelFor(value) {
      for (var i = 0; i < LEVELS.length; i++) if (value < LEVELS[i].max) return LEVELS[i];
      return LEVELS[LEVELS.length - 1];
    }

    function lookup(zip) {
      if (DATA[zip]) return DATA[zip];                 // code postal précis
      if (DATA[zip.slice(0, 3)]) return DATA[zip.slice(0, 3)];  // outre-mer
      if (DATA[zip.slice(0, 2)]) return DATA[zip.slice(0, 2)];  // département
      return null;
    }

    function setHint(message, isError) {
      if (!elHint) return;
      elHint.textContent = message || hintBase;
      elHint.classList.toggle('is-error', !!isError);
    }

    function render(zip) {
      var entry = lookup(zip);

      if (!entry) {
        result.hidden = true;
        setHint("Code postal introuvable. Vérifiez la saisie, ou consultez directement la donnée officielle de votre commune.", true);
        return;
      }

      setHint('', false);

      var mid = (entry.min + entry.max) / 2;
      var level = levelFor(mid);

      elValue.textContent = entry.min + '–' + entry.max;
      elPlace.textContent = entry.n + ' · ' + zip;
      elBadge.textContent = level.label;
      elBadge.setAttribute('data-level', level.key);

      // Position sur l'échelle, plafonnée à 45 °f
      var pct = Math.max(3, Math.min(97, (mid / 45) * 100));
      elMarker.style.left = pct + '%';

      elText.textContent = level.text;

      elFacts.innerHTML = level.facts.map(function (f) {
        return '<li>' + f.replace(/[&<>]/g, '') + '</li>';
      }).join('');

      if (elUrgency) {
        elUrgency.innerHTML = 'Une douche par jour, c\'est <strong>365 passages par an</strong> dans cette eau. ' +
                              'Elle ne changera pas — votre pommeau, si.';
      }

      result.hidden = false;
      if (result.scrollIntoView) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 5);
      if (input.value.length === 5) render(input.value);
      else if (result.hidden === false && input.value.length < 5) setHint('', false);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = input.value.replace(/\D/g, '');
      if (zip.length !== 5) { setHint("Un code postal français compte cinq chiffres.", true); return; }
      render(zip);
    });
  });

  /* ---------------------------------------------------------------------
     Formulaires d'adresse (pays / région)
     --------------------------------------------------------------------- */
  $$('[data-address-country]').forEach(function (countrySelect) {
    var form = countrySelect.closest('form');
    var provinceSelect = form ? form.querySelector('[data-address-province]') : null;
    if (!provinceSelect) return;
    var wrapper = provinceSelect.closest('[data-address-province-wrapper]');

    function populate() {
      var opt = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (err) {}
      provinceSelect.innerHTML = '';
      if (!provinces.length) { if (wrapper) wrapper.style.display = 'none'; return; }
      if (wrapper) wrapper.style.display = '';
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        provinceSelect.appendChild(o);
      });
    }

    var def = countrySelect.getAttribute('data-default');
    if (def) {
      for (var i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value === def) { countrySelect.selectedIndex = i; break; }
      }
    }
    populate();
    countrySelect.addEventListener('change', populate);
  });

})();
